import { useQueryClient } from '@tanstack/react-query'

import { Modal } from '@/components/ui/Modal'
import { NaukriConnect } from '@/features/onboarding/NaukriConnect'

/** The Naukri sign-in flow in a dialog, for connecting (or reconnecting) from anywhere. */
export function NaukriConnectModal({
  open,
  onClose,
  onConnected,
  reconnect,
}: {
  open: boolean
  onClose: () => void
  onConnected?: () => void
  reconnect?: boolean
}) {
  const queryClient = useQueryClient()

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={reconnect ? 'Reconnect your Naukri account' : 'Connect your Naukri account'}
      description={
        reconnect
          ? 'Sign in again so we can apply with your live Naukri account.'
          : 'Log into an existing account or create one.'
      }
      size="md"
    >
      <div className="pb-4">
        <NaukriConnect
          onDone={() => {
            onClose()
            queryClient.invalidateQueries({ queryKey: ['integrations'] })
            queryClient.invalidateQueries({ queryKey: ['job-sources'] })
            onConnected?.()
          }}
          onSkip={onClose}
        />
      </div>
    </Modal>
  )
}
